import {combineReducers} from "redux";


import appStateReducer, {appInitialState} from "./appstate";
import schoolInfoReducer, {schoolInfoInitialState} from "./schoolinfo";


const initialState = {
    appState: appInitialState,
    schoolInfo: schoolInfoInitialState,
};


const reducer = combineReducers({
    appState: appStateReducer,
    schoolInfo: schoolInfoReducer,
});


export {
    reducer as default,
    reducer,
    initialState,
};
